module.exports = __webpack_public_path__ + "static/img/tag-xunlianying@2x.6c1bd51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tag-xunlianying@2x.png
// module id = 1623
// module chunks = 0